import { ThemeTonalRange } from '@philips-internal/oswald-ui-components';

import { DialogType, ModalType, SimpleDialog, SimpleDialogParams } from '../../dialog-helper/dialog-helper';

import ApprovalProcessModal from './approval-process-modal';
import { ApprovalOrderItemResponse } from './approval-process-modal-business';
import { ApprovalProcessParams } from './approval-process-params';
import { NextStepMethod } from './next-step-method-enums';

export class ApprovalProcessDialogs {

  static openDialogNextStep(params: ApprovalProcessParams, nextStep: NextStepMethod): void {
    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: params.descriptionDialog,
      dialogType: DialogType.ACTION,
      modalType: ModalType.DIALOG,
      onClickCancel: () => { return; },
      onClickOk: () => { ApprovalProcessDialogs.processNextStep(nextStep, params); },
      titleDialog: 'approvals.action.approve',
      titleOnCancel: 'tws.form.cancel',
      titleOnOk: 'approval.confirm',
      theme: ThemeTonalRange.VERY_DARK,
    };
    SimpleDialog.openDialog(dialogParams);
  }

  private static processNextStep(nextStep: NextStepMethod, params: ApprovalProcessParams): void {
    switch (nextStep) {
      case NextStepMethod.CONFIRM:
        ApprovalProcessModal.confirm(ApprovalProcessDialogs.checkNull(params.approvalSeq),
          ApprovalProcessDialogs.checkNull(ApprovalProcessDialogs.checkNull(params.approvalProcessSeq)));
        break;
      case NextStepMethod.APPROVE_ORDER_ITEM_SECOND_STEP:
        ApprovalProcessModal.approveOrderItemSecondStep(ApprovalProcessDialogs.checkNull(params.approvalSeq),
          ApprovalProcessDialogs.checkNull(params.approvalProcessSeq), params.orderType, ApprovalProcessDialogs.checkNullNumber(params.documentNumber), params.purchaseRequestNumber);
        break;
      case NextStepMethod.FORWARD_BALANCE_APPROVAL:
        ApprovalProcessModal.forwardBalanceApproval(ApprovalProcessDialogs.checkNull(params.approvalSeq), ApprovalProcessDialogs.checkNull(params.approvalProcessSeq));
        break;
      case NextStepMethod.VALIDATE_PURCHASE_UNIT_VALUE:
        ApprovalProcessModal.validatePurchaseUnitValue(params.approveOrderItemResponse != null ? params.approveOrderItemResponse : {} as ApprovalOrderItemResponse,
          ApprovalProcessDialogs.checkNull(params.approvalSeq), ApprovalProcessDialogs.checkNull(params.approvalProcessSeq));
        break;
      case NextStepMethod.GENERATE_PURCHASE_REQUEST_INTEGRATION:
        ApprovalProcessModal.generatePurchaseRequestIntegration(ApprovalProcessDialogs.checkNullNumber(params.purchaseRequestNumber),
          ApprovalProcessDialogs.checkNullString(params.typeInterfaceIntegration));
        break;
      case NextStepMethod.APPROVE_PURCHASE:
        ApprovalProcessModal.approvePurchase(ApprovalProcessDialogs.checkNull(params.approvalSeq),
          ApprovalProcessDialogs.checkNull(params.approvalProcessSeq),
          params.orderType, ApprovalProcessDialogs.checkNullNumber(params.documentNumber), params.purchaseRequestNumber);
        break;
      case NextStepMethod.FINISH_ORDER_APPROVAL:
        ApprovalProcessModal.finishOrderApproval(ApprovalProcessDialogs.checkNull(params.approvalSeq), ApprovalProcessDialogs.checkNull(params.approvalProcessSeq));
        break;
      default:
        break;
    }
  }

  private static checkNull(param: string | number | undefined): string | number {
    return param != null ? param : 0;
  }

  private static checkNullNumber(param: number | undefined): number {
    return param != null ? param : 0;
  }

  private static checkNullString(param: string | undefined): string {
    return param != null ? param : '';
  }

  static openDialogOk(descriptionDialog: string): void {
    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: descriptionDialog,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: () => { return; },
      titleDialog: 'approvals.action.approve',
      titleOnOk: 'approval.ok',
      theme: ThemeTonalRange.VERY_DARK,
    };
    SimpleDialog.openDialog(dialogParams);
  }
}
